export default "__VITE_ASSET__HbW44a$f__"